import type {FC} from 'react';
import {CommonLink} from '../../../../../shared/components/CommonLink';

export const Tag: FC<{name: string}> = ({name}) => {
  return (
    <CommonLink href={`/column/tag/${name}`}>
      <span className="text-[12px] text-nowrap px-8 py-4 rounded-16 border border-black">
        {name}
      </span>
    </CommonLink>
  );
};
